import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { formatINRNumber } from "@/utils/format";
import { useThemeColors } from "@/hooks/useThemeColors";

export function GroupPerformanceChart({ data }: { data: { name: string; collected: number; expected: number; pct: number }[] }) {
  const theme = useThemeColors();
  const rows = data.map((d) => ({ name: d.name, Collected: d.collected, Expected: d.expected }));
  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={rows} margin={{ top: 8, right: 8, left: 4, bottom: 0 }}>
        <CartesianGrid stroke={theme.grid} vertical={false} />
        <XAxis dataKey="name" tick={{ fontSize: 11, fill: theme.text }} axisLine={false} tickLine={false} interval={0} angle={-20} textAnchor="end" height={52} />
        <YAxis tick={{ fontSize: 11, fill: theme.text }} axisLine={false} tickLine={false} width={64} tickFormatter={(v) => `₹${Math.round(Number(v) / 1000)}k`} />
        <Tooltip
          formatter={(value, name) => [formatINRNumber(Number(value)), name === "Collected" ? "Collected" : "Expected"]}
          contentStyle={{ borderRadius: 8, border: "none", fontSize: 12, background: theme.tooltipBg, color: theme.tooltipText }}
          labelStyle={{ color: theme.tooltipText }}
          cursor={{ fill: theme.primary200 }}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="Expected" name="Expected" fill={theme.primary200 ?? theme.primary} radius={[3, 3, 0, 0]} maxBarSize={20} />
        <Bar dataKey="Collected" name="Collected" fill={theme.primary} radius={[3, 3, 0, 0]} maxBarSize={20} />
      </BarChart>
    </ResponsiveContainer>
  );
}